import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Btn, Field } from "@/components/shared";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [f, setF] = useState({ login: "", otp: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const sendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { const { data } = await api.post("/auth/forgot-password", { login: f.login }); toast.info(data.message); setStep(2); } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  const reset = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { login: f.login, otp: f.otp, new_password: f.new_password });
      toast.success(data.message);
      nav("/login");
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="np-card w-full max-w-sm p-6 fade-up">
        <Link to="/login" className="mb-4 flex items-center gap-1 text-xs font-semibold text-blue-700" data-testid="back-to-login-link"><ArrowLeft className="h-3.5 w-3.5" />Back to login</Link>
        <h2 className="font-display text-2xl font-bold">Forgot password</h2>
        <p className="mt-1 text-sm text-slate-500">{step === 1 ? "We'll send an OTP to your registered mobile." : "Enter the OTP and choose a new password."}</p>
        {step === 1 ? (
          <form onSubmit={sendOtp} className="mt-6 space-y-4" data-testid="forgot-form">
            <Field label="Mobile / Login ID"><input className="np-input" value={f.login} onChange={set("login")} required data-testid="forgot-login-input" /></Field>
            <Btn type="submit" loading={loading} className="w-full" data-testid="forgot-send-otp-button">Send OTP</Btn>
          </form>
        ) : (
          <form onSubmit={reset} className="mt-6 space-y-4" data-testid="reset-form">
            <Field label="OTP"><input className="np-input font-mono" maxLength={6} value={f.otp} onChange={set("otp")} required data-testid="reset-otp-input" /></Field>
            <Field label="New Password"><input type="password" className="np-input" value={f.new_password} onChange={set("new_password")} required data-testid="reset-password-input" /></Field>
            <Field label="Confirm Password"><input type="password" className="np-input" value={f.confirm} onChange={set("confirm")} required data-testid="reset-confirm-input" /></Field>
            <Btn type="submit" loading={loading} className="w-full" data-testid="reset-submit-button">Reset Password</Btn>
          </form>
        )}
      </div>
    </div>
  );
}
